import { render, staticRenderFns } from "./WHOISMonitoringList.vue?vue&type=template&id=2d97b814&scoped=true&"
import script from "./WHOISMonitoringList.vue?vue&type=script&lang=js&"
export * from "./WHOISMonitoringList.vue?vue&type=script&lang=js&"
import style0 from "./WHOISMonitoringList.vue?vue&type=style&index=0&id=2d97b814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97b814",
  null
  
)

export default component.exports